import { TableRow } from '@material-ui/core';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import Swal from 'sweetalert2';
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles';
import * as Utils from '../../commons/utils/Utils';
import backendStrings from '../../lang/backendStrings.js';

const ESTADO_CONFIG = {
    BORRADOR:  { label: 'Borrador',  color: '#6c757d' },
    VIGENTE:   { label: 'Vigente',   color: '#28a745' },
    CERRADO:   { label: 'Cerrado',   color: '#343a40' },
};

export const puedeEliminarPrograma = (permissions, programa) =>
    Boolean(permissions && permissions.eliminar && programa && programa.eliminable);

export const puedeEditarPrograma = (permissions, programa) =>
    Boolean(permissions && permissions.editar && programa && programa.editable);

export const claveDeError = (err) => {
    const detalle = err && err.response && err.response.data && err.response.data.detalle;
    return Array.isArray(detalle) ? detalle[0] : detalle;
};

const ProgramasPreventivosGridRow = (props) => {
    const programa = props.programa;
    const permissions = props.permissions;
    const baseUrl = props.baseUrl;
    const [redirectTo, setRedirectTo] = useState(null);
    const intl = useIntl();

    const escapeHtml = (texto) => {
        const div = document.createElement('div');
        div.textContent = texto || '';
        return div.innerHTML;
    };

    const eliminarPrograma = () => {
        Swal.fire({
            title: intl.formatMessage({ id: '¿Confirma la eliminación?', defaultMessage: '¿Confirma la eliminación?' }),
            html: intl.formatMessage({ id: 'programasPreventivosGridRow.eliminar_swal.texto', defaultMessage: 'Se eliminará el programa' }) + ': <b>' + escapeHtml(programa.nombre) + '</b>',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: intl.formatMessage({ id: 'Si', defaultMessage: 'Si' }),
            cancelButtonText: intl.formatMessage({ id: 'No', defaultMessage: 'No' }),
        }).then((result) => {
            if (result.value) {
                Utils.deleteData('/programas-preventivos/' + programa.id)
                    .then(() => {
                        props.fetchProgramas();
                        Swal(intl.formatMessage({ id: 'Eliminado!', defaultMessage: 'Eliminado!' }), '', 'success');
                    })
                    .catch((err) => {
                        const clave = claveDeError(err);
                        Swal(
                            backendStrings[clave]
                                ? intl.formatMessage(backendStrings[clave])
                                : intl.formatMessage({ id: 'errors.default', defaultMessage: 'Error' }),
                            '',
                            'error',
                        );
                    });
            }
        });
    };

    const estadoCfg = ESTADO_CONFIG[programa.estado] || { label: programa.estado, color: '#6c757d' };

    return (
        <>
            {redirectTo && <Redirect push to={redirectTo} />}
            <TableRow hover>
                <StyledTableCell align="left">
                    {programa.nombre}
                </StyledTableCell>
                <StyledTableCell align="left">
                    {programa.fecha_inicio} → {programa.fecha_fin}
                </StyledTableCell>
                <StyledTableCell align="left">
                    <span style={{
                        backgroundColor: estadoCfg.color,
                        color: '#fff',
                        borderRadius: '4px',
                        padding: '2px 10px',
                        fontSize: '12px',
                        fontWeight: 500,
                    }}>
                        {estadoCfg.label}
                    </span>
                </StyledTableCell>
                <StyledTableCell align="center">
                    {programa.vehiculos_incluidos}
                </StyledTableCell>
                <StyledTableCell align="center">
                    {programa.vehiculos_excluidos}
                </StyledTableCell>
                <StyledTableCell align="left">
                    {programa.updated_at}
                </StyledTableCell>
                <StyledTableCell align="center">
                    <div className="d-inline-flex">
                        {permissions.visualizar && (
                            <button
                                className="action view btn btn-sm btn-icon btn-dt-grid text-success"
                                title="Ver"
                                data-toggle="tooltip"
                                data-placement="top"
                                onClick={() => setRedirectTo(baseUrl + '/' + programa.id)}
                            >
                                <i className="fa fa-search fa-xs" />
                            </button>
                        )}
                        {puedeEditarPrograma(permissions, programa) && (
                            <button
                                className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                                title={intl.formatMessage({ id: 'programasPreventivosGridRow.editar', defaultMessage: 'Editar' })}
                                data-toggle="tooltip"
                                data-placement="top"
                                onClick={() => setRedirectTo(baseUrl + '/' + programa.id + '/edit')}
                            >
                                <i className="fa fa-pencil fa-xs" />
                            </button>
                        )}
                        {puedeEliminarPrograma(permissions, programa) && (
                            <button
                                className="action delete btn btn-sm btn-icon btn-dt-grid text-danger"
                                title={intl.formatMessage({ id: 'programasPreventivosGridRow.eliminar', defaultMessage: 'Eliminar' })}
                                data-toggle="tooltip"
                                data-placement="top"
                                onClick={eliminarPrograma}
                            >
                                <i className="fa fa-trash fa-xs" />
                            </button>
                        )}
                    </div>
                </StyledTableCell>
            </TableRow>
        </>
    );
};

export default ProgramasPreventivosGridRow;
